import React from 'react'
import { useLocation, useParams } from 'react-router';
import queryString from 'query-string'
import PageContainer from '../../../layout/PageContainer';
import FacturacionCredito from './FacturacionCredito';


const FacturacionCreditoContainer = () => {
  const { policyId } = useParams();
  const { search } = useLocation();
  const clienteId = queryString.parse(search).client_id
  return (
    <PageContainer
      breadcrumbs={[
        { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
        { id: 1, name: 'ASEGURADO', url: '/asegurado/polizas-credito' },
        { id: 2, name: 'FACTURACIÓN' },
      ]}
      clientFilter={{
        type: 'asegurado',
        ramo: 'credito',
        showFilter: false,
      }}
    >
      {(client) => (
        <FacturacionCredito
          policyId={policyId}
          client={client}
          clientAsIntermediaryId={clienteId}
        />
      )}
    </PageContainer>
  );
};

export default FacturacionCreditoContainer;
